/* Black Deer — Core Web Vitals ölçümü
   LCP, CLS, INP değerlerini tarayıcıdan okur ve dataLayer'a yazar.
   Sadece gerçek ölçülen değerler gönderilir, tahmin yoktur.
   Örnekleme: tüm oturumların %25'i (analitik hesabı şişmesin diye). */
(function(){
  if (Math.random() > 0.25) return;

  function bildir(ad, deger, seviye, ek){
    var veri = Object.assign({
      event: 'bd_web_vital',
      metrik: ad,
      deger: Math.round(deger * 1000) / 1000,
      seviye: seviye
    }, ek || {});
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(veri);
    window.dispatchEvent(new CustomEvent('bd:analitik', { detail: veri }));
  }

  function seviye(ad, v){
    if (ad === 'CLS') return v <= 0.1 ? 'iyi' : v <= 0.25 ? 'orta' : 'kotu';
    if (ad === 'INP') return v <= 200 ? 'iyi' : v <= 500 ? 'orta' : 'kotu';
    return v <= 2500 ? 'iyi' : v <= 4000 ? 'orta' : 'kotu';
  }

  // LCP — en büyük içerik boyaması
  try {
    new PerformanceObserver(function(liste){
      var g = liste.getEntries();
      var son = g[g.length - 1];
      if (son) bildir('LCP', son.startTime, seviye('LCP', son.startTime), {
        element: son.element ? son.element.tagName : undefined
      });
    }).observe({ type: 'largest-contentful-paint', buffered: true });
  } catch(e){}

  // CLS — düzen kayması
  var cls = 0;
  try {
    new PerformanceObserver(function(liste){
      liste.getEntries().forEach(function(g){ if (!g.hadRecentInput) cls += g.value; });
    }).observe({ type: 'layout-shift', buffered: true });
    addEventListener('visibilitychange', function(){
      if (document.visibilityState === 'hidden') bildir('CLS', cls, seviye('CLS', cls));
    }, { once: true });
  } catch(e){}

  // INP — etkileşim gecikmesi
  try {
    var enKotu = 0;
    new PerformanceObserver(function(liste){
      liste.getEntries().forEach(function(g){
        if (g.interactionId && g.duration > enKotu) enKotu = g.duration;
      });
    }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
    addEventListener('pagehide', function(){
      if (enKotu) bildir('INP', enKotu, seviye('INP', enKotu));
    }, { once: true });
  } catch(e){}

  // Sayfa yükleme türü ve toplam süre
  addEventListener('pagehide', function(){
    try {
      var n = performance.getEntriesByType('navigation')[0];
      if (!n) return;
      bildir('TTFB', n.responseStart, seviye('TTFB', n.responseStart), { tur: n.type });
    } catch(e){}
  }, { once: true });
})();
